  export class TransactionFailedRecord {
    processDetailId: number;
    processId: number;
    userName: string;
    ssoId: string;
    status: string;
    failedReason: string;
  }

  export class Transaction {
    processId: number;
    customerName: string;
    crmId: string;
    configId: number;
    userCount: number;
    successCount: number;
    failureCount: number;
    status: string;
    startedBy: string;
    startedDateTimeGMT: Date | string;
    endedDateTimeGMT: String;
    corporationName: string;
    environmentName: string;
    environmentId?: number;
    corpId?: number;
    download?: boolean;
    validationSuccessCount?: number;
    validationErrorCount?: number;
  }

export class TransactionStatusOptions {
  static InProgress = "InProgress";
  static Completed = "Completed";
  static Failed = "Failed";
  static CompletedWithErrors = "CompletedWithErrors";
}
